<template>
  <a
    v-if="addHref"
    :class="[
      className,
      {
        'anz-btn-text': textButton,
        disabled: disabled | loading,
        'anz-flex-inline anz-align-items-center anz-justify-content-center': loading,
      },
    ]"
    :disabled="disabled"
    :href="href"
    :target="targetBlank ? '_blank' : '_self'"
    :title="tooltipTitle"
  >
    <a-icon
      v-if="showIcon && !loading"
      :width="iconWidth"
      :height="iconHeight"
      :name="iconName"
      :class="iconClass"
    />
    <div
      v-if="loading"
      class="anz-inline-block"
      :style="{
        width: iconWidth,
        height: iconHeight,
      }"
    >
      <a-loader v-if="loading" block :class-name="loaderClass" />
    </div>
    <slot name="title"> {{ title }}</slot>
  </a>
  <a
    v-else
    :class="[
      className,
      {
        'anz-btn-text': textButton,
        disabled: disabled | loading,
        'anz-flex-inline anz-align-items-center anz-justify-content-center': loading,
      },
    ]"
    @click="onclick"
    :disabled="disabled"
    :title="tooltipTitle"
  >
    <a-icon
      v-if="showIcon && !loading"
      :width="iconWidth"
      :height="iconHeight"
      :name="iconName"
      :class="iconClass"
    />
    <div
      v-if="loading"
      class="anz-inline-block"
      :class="iconClass"
      :style="{
        width: iconWidth,
        height: iconHeight,
      }"
    >
      <a-loader v-if="loading" block :class-name="loaderClass" />
    </div>
    <slot name="title">{{ title }}</slot>
  </a>
</template>

<script>
import AIcon from '@/components/AIcon'
import ALoader from '@/components/ALoader'

export default {
  name: 'AButton',
  components: { ALoader, AIcon },
  emits: ['click'],
  props: {
    title: {
      type: String,
      default: '',
    },
    tooltipTitle: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    targetBlank: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: 'anz-btn',
    },
    textButton: {
      type: Boolean,
      default: false,
    },
    addHref: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    iconWidth: {
      type: String,
      default: '',
    },
    iconHeight: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    loaderClass: {
      type: String,
    },
  },
  methods: {
    onclick(event) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
  },
}
</script>
